<template>
  <div class="footer-wrap">
    <div class="keep-record-wrap">
      <p style="padding-bottom: 15px;">© 版权所有：中国律师网 www.acla.org.cn 2002-2017</p>
      <p style="padding-bottom: 30px;">ICP备：京ICP备14005197号-2</p>
      <img src="/images/sm-logo.png" alt="">
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
  },
  name: "footerbox",
  data() {
    return {
      linkArr: [
        { name: '中国律师网', url: 'javacript:;' },
        { name: '中国法律服务网', url: 'javacript:;' },
        { name: '中国普法网', url: 'javacript:;' },
        { name: '中国律师培训网', url: 'javacript:;' },
        { name: '中华人民共和国司法部', url: 'javacript:;' }
      ]
    };
  },
  methods: {
    ...mapActions([])
  },
  watch: {
  },
  computed: {
    ...mapGetters([])
  },
  created() {},
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss">
@import "../assets/scss/variables";
@import "../assets/scss/mixins";
.footer-wrap {
  width: 100%;
  height: auto;
  margin-top: 86px;
  background-color: #f8f8f8;
  text-align: center;
  .link-wrap .wrapper {
    width: 768px;
    height: 100px;
    line-height: 100px;
    display: flex;
    justify-content: space-between;
    a {
      color: #4b8dfd;
    }
    a:hover {
      border-bottom: 1px solid #4b8dfd;
    }
  }
  .keep-record-wrap {
    width: 100%;
    height: auto;
    padding-top: 40px;
    padding-bottom: 36px;
    background: #297bc3;
    p {
      margin: 0;
      line-height: 100%;
      color: $white;
    }
  }
}
</style>